const PublicLayoutConfig = {
  // Setting the layout name to 'auth'
  name: 'public',
  // Options object is currently empty but can be extended with layout-specific configurations
  options: {}
};
export { PublicLayoutConfig };